<template>
<div class="row plain-element">
  <div v-if="!isLoggedIn()" class="dashboard-cards">
    <NoPermissionComponent/>
  </div>
  <div v-if="getUsername() && getCorporatePlanData()" class="dashboard-site">
    <div class="row plain-element top-menu">
      <ul>
        <li>
          <router-link :to="{name: 'home'}" class="horizontal-link">Home</router-link>
        </li>
        <li>
          <router-link :to="{name: 'corporate-plan-search'}" class="horizontal-link">Corporate Plan Search
          </router-link>
        </li>
        <li>
          <router-link :to="{name: 'corporate-plan-create'}" class="horizontal-link">Create Corporate Plan</router-link>
        </li>
      </ul>
    </div>
    <div class="card card-details">
      <div class="row plain-element">
        <div class=" col col-12 col-sm-12 col-md-12 col-lg-12 plain-element">
          <div class="row row-functions text-start">
            <div class=" col col-12 col-sm-12 col-md-12 col-lg-1 plain-element">
              <img alt="img" :src="'https://saperapublicstorage.blob.core.windows.net/media/logos/' + getCompanyString() + '.png'"
                   class="img responsive img-icon">
            </div>
            <div class=" col col-12 col-sm-12 col-md-12 col-lg-4 plain-element text-start">
              <h3 v-if="getCorporatePlanData().name.length < 46"  >{{ truncatechars(getCorporatePlanData().name, 50) }}</h3>
              <h4 v-else  id="h4-line-height-32">{{ truncatechars(getCorporatePlanData().name, 60) }}</h4>
            </div>
            <div class=" col col-12 col-sm-12 col-md-12 col-lg-7 plain-element col-buttons">
              <a :href="'/api/full-download-corporate-plan/' + id" class="btn btn-report">
                  Excel
              </a>
              <router-link v-if="getCorporatePlanData().plan_manager ===  getUsername()"  :to="{name: 'corporate-plan-update', params: {id: id}}" class="btn btn-report">
                Update
              </router-link>
              <router-link v-if="getCorporatePlanData().plan_manager ===  getUsername()" :to="{name: 'attach-remove-corporate-site-plan', params: {id: id}}" class="btn btn-report">
                Attach Plans
              </router-link>
            </div>
          </div>
        </div>
      </div>
      <div class="row plain-element">
        <CorporatePlanTabsComponent
          :id = getCorporatePlanData().id.toString()
          :tab = tab
          :opportunity_plan_relations_length = getCorporatePlanData().opportunity_plan_relations.opportunity_plan_relations.length
        />
      </div>
      <p v-if="tab==='plan-details'" class="w-100"></p>
      <div v-if="tab==='plan-details'" class="row plain-element">
        <CorporatePlanDetailsComponent
          :corporatePlanData = getCorporatePlanData()
        />
      </div>
      <div  v-if="tab === 'opportunities' " class="row plain-element">
        <CorporatePlanOpportunitiesComponent
          :id = getCorporatePlanData().id.toString()
          :site_seus = getCorporatePlanData().opportunity_plan_relations.nested_site_seu
          :opportunities = getCorporatePlanData().opportunity_plan_relations.opportunity_plan_relations
          :currency_details = getCorporatePlanData().currency_details
          :carbonPerEuroDict = getCarbonPerEuroDict()
          :currency = getCorporatePlanData().currency
          :siteNames = getSiteNames()
        />
      </div>
      <div  v-if="tab === 'site-plans' " class="row plain-element">
        <CorporatePlanSitePlansComponent
          :id = getCorporatePlanData().id.toString()
          :site_plans = getCorporatePlanData().corporate_site_plan_relations.corporate_site_plan_relations
          :opportunities = getCorporatePlanData().opportunity_plan_relations.opportunity_plan_relations
          :currency_details = getCorporatePlanData().currency_details
          :carbonPerEuroDict = getCarbonPerEuroDict()
          :currency = getCorporatePlanData().currency
          :siteNames = getSiteNames()
          :plan_manager = getCorporatePlanData().plan_manager
        />
      </div>
      <div v-if="tab === 'financial-graphs'" class="row plain-element">
        <CorporatePlanFinancialGraphsComponent
          :opportunity_plan_relations_length = getCorporatePlanData().opportunity_plan_relations.opportunity_plan_relations.length
          :investmentWaterfallChartData = getInvestmentWaterfallChartData()
          :costSavingsWaterfallChartData = getCostSavingsWaterfallChartData()
          :investmentChartData = getInvestmentChartData()
          :financialClimateActionPhaseWaterfallChartData = getFinancialClimateActionPhaseWaterfallChartData()
          :costSavingsChartData = getCostSavingsChartData()
          :carbonPerEuroChartData = getCarbonPerEuroChartData()
          :currency_details = getCorporatePlanData().currency_details
        />
      </div>
      <div v-if="tab === 'climate-graphs'" class="row plain-element">
        <CorporatePlanClimateGraphsComponent
          :opportunity_plan_relations_length = getCorporatePlanData().opportunity_plan_relations.opportunity_plan_relations.length
          :carbonClimateActionPhaseWaterfallChartData = getCarbonClimateActionPhaseWaterfallChartData()
          :carbonWaterfallChartData = getCarbonWaterfallChartData()
          :carbonChartData = getCarbonChartData()
          :corporatePlanCarbonTracker = getCorporatePlanCarbonTracker()
          :plan_manager = getCorporatePlanData().plan_manager
          :siteNames = getCorporatePlanData().site_names
          :site_carbon_reduction_per_climate_action_phase = getCorporatePlanData().site_carbon_reduction_per_climate_action_phase
          :site_total_carbon_chart_data = getCorporatePlanData().site_total_carbon_chart_data
          :id = getCorporatePlanData().id
        />
      </div>
    </div>
  </div>
</div>
</template>

<script>

import {  sortTableNew, sortOppTableCurrencyInt, sortPlanTable, sortPlanTableCurrencyInt } from "@/common/tables.js";
import { mapGetters, mapActions } from "vuex";
import { hasHistory, truncatechars } from "@/common/general.js";

import CorporatePlanTabsComponent from "@/components/corporate_plans/CorporatePlanTabsComponent.vue";
import CorporatePlanDetailsComponent from "@/components/corporate_plans/CorporatePlanDetailsComponent.vue";
import CorporatePlanOpportunitiesComponent from "@/components/corporate_plans/CorporatePlanOpportunitiesComponent.vue";
import CorporatePlanSitePlansComponent from "@/components/corporate_plans/CorporatePlanSitePlansComponent.vue";
import CorporatePlanFinancialGraphsComponent from "@/components/corporate_plans/CorporatePlanFinancialGraphsComponent.vue";
import CorporatePlanClimateGraphsComponent from "@/components/corporate_plans/CorporatePlanClimateGraphsComponent.vue";

import NoPermissionComponent from "@/components/NoPermissionComponent.vue";


export default {
  name: "CorporatePlanView",
  props: {
    id: {
      type: String,
      required: true,
    },
    tab: {
      type: String,
      required: true,
    }
  },
  data() {
    return {
      activeTab: "planDetails",
    }
  },
  components: {
    CorporatePlanTabsComponent,
    CorporatePlanDetailsComponent,
    CorporatePlanOpportunitiesComponent,
    CorporatePlanSitePlansComponent,
    CorporatePlanFinancialGraphsComponent,
    CorporatePlanClimateGraphsComponent,
    NoPermissionComponent,

  },
  mounted() {

  },
  methods: {
    ...mapGetters(["getCorporatePlanData", "getUsername", "isLoggedIn", "getCompanyString","getInvestmentWaterfallChartData",
                    "getInvestmentChartData", "getCarbonChartData","getCarbonWaterfallChartData", "getCostSavingsChartData","getCorporatePlanCarbonTracker",
                    "getCostSavingsWaterfallChartData", "getCostSavingsChartData", "getCarbonClimateActionPhaseWaterfallChartData",
                    "getFinancialClimateActionPhaseWaterfallChartData", "getSiteNames", "getCarbonPerEuroChartData","getSiteNames",
                    "getCarbonPerEuroDict"]),
    ...mapActions(["fetchCorporatePlanData", "performSetFormError", "fetchCorporatePlanCarbonTracker", "performSetSiteSpecificAnnualWaterfall", "fetchSiteNames"]),
    truncatechars: truncatechars,
    hasHistory: hasHistory,
    sortTableNew: sortTableNew,
    sortPlanTable: sortPlanTable,
    sortPlanTableCurrencyInt: sortPlanTableCurrencyInt,
    sortOppTableCurrencyInt: sortOppTableCurrencyInt,

    getCorporatePlanDetails(id) {
      this.fetchCorporatePlanData({"id": id })
    },


  },
  computed: {

  },
  created() {
    this.getCorporatePlanDetails(this.id);
    this.fetchCorporatePlanCarbonTracker({"id":this.id});
    this.performSetFormError(null);
    this.fetchSiteNames()
    document.title = "Corporate Plan Details";
    window.scrollTo(0,0);
  },
  beforeRouteUpdate (to, from, next) {
    this.chosenId = to.params.id;
    this.getCorporatePlanDetails(this.chosenId);
    this.fetchCorporatePlanCarbonTracker({"id":this.chosenId});
    next();
  }

}
</script>
